export default "__VITE_ASSET__ClHr1Kp___"